<template>
  <div class="children-dossier">
  <div>
    <div class="row">
      <div class="col-12">
        <h3>Meldcode</h3>
        <p class="alert alert-secondary">
          Nieuwe notitie
        </p>
        <br>
        <div class="row">
          <div class="col-12 ms-auto">
            <textarea
              v-model="note"
              class="form-control"
              rows="5"
              placeholder="Nieuwe notitie..."
              v-focus
            />
          </div>
        </div>
      </div>
      <div class="col-12" style="margin-top: 5px">
        <br>
          <div class="d-grid">
              <button v-on:click="addDossiesNotes()" type="button" class="btn btn-block btn-info">
                  Opslaan
              </button>
          </div>
       <br>
      </div>
     </div>
   </div>
    <div v-if="specialCareNotes" class="row">
      <div v-for="(note, index) in specialCareNotes" :key="index" class="col-12">
        <div style="background: #f0f0f5; padding: 20px; padding-bottom: 10px; margin-bottom: 10px">
          <p style="text-align: justify">
            <b>
              {{ this.$moment(note.date).format('dddd D MMMM YYYY HH:mm') }}
            </b>
            -
            <span class="fst-italic">
              {{ note.employee }}
            </span>
            <br>
            <br>
            {{ note.note }}
            <br>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'children-dossier',
  computed: {
    specialCareNotes () {
      return this.$store.getters.specialCareNotes
    }
  },
  data () {
    return {
      note: null
    }
  },
  created () {
    // this.$store.commit('SET_SPECIAL_CARE_NOTES', [])
  },
  methods: {
    addDossiesNotes () {
      var notes = this.specialCareNotes
      notes.unshift(
        {
          date: '2019-06-27 15:02:20',
          note: this.note,
          employee: 'Medewerker X'
        }
      )
      this.$store.commit('SET_SPECIAL_CARE_NOTES', notes)
      this.note = null
    }
  },
  props: ['id']
}
</script>

<style scoped>
</style>
